import { FeatureFlags, useFeatureFlags } from '@/helper/FeatureFlags';
import { useAdminRoute } from '@/pages/corporate/routes/hooks/useAdminRoutes';
import { PerformanceStatusEnum } from '@/types/schema';

import useContentAccessed from '../../hooks/useContentAccessed';

interface ContentAccessEventsProps {
  entityId: string;
  performanceStatus?: PerformanceStatusEnum;
  pause?: boolean;
  recalibrationRequired?: boolean;
}

const ContentAccessEvents: React.FC<ContentAccessEventsProps> = ({
  entityId,
  performanceStatus,
  pause,
  recalibrationRequired,
}) => {
  const isAdminRoute = useAdminRoute();

  const {
    [FeatureFlags.DisableContentAccessEventOnCompletion]: disableContentAccessEventOnCompletion,
  } = useFeatureFlags();

  const disableContentAccessEvents = Boolean(
    disableContentAccessEventOnCompletion && performanceStatus === PerformanceStatusEnum.Completed,
  );

  useContentAccessed({
    entityId,
    pause: !entityId || pause || isAdminRoute,
    recalibrationRequired,
    sendContentAccessedEvent: !disableContentAccessEvents,
  });

  return null;
};

export default ContentAccessEvents;
